import { Button } from '@mantine/core'
import { MessageChatCircle } from '@untitled-ui/icons-react'
import Box from '@/components/ui/Box'
import CommentsButton from '@/components/ui/CommentsButton'

export default function ServiceCaseNote({ serviceCase }) {
    return (
        <Box title="Note partagée">
            {serviceCase.private_note ? (
                <span className="text-gray-500 whitespace-pre-line">
                    {serviceCase.private_note}
                </span>
            ) : (
                <span className="text-gray-400">Aucune note</span>
            )}

            <div className="mt-3 pt-3 border-t flex items-center gap-2 text-sm text-gray-400">
                <MessageChatCircle width={14} height={14} />
                <span>Utilisez les commentaires pour échanger sur ce dossier</span>
                <div className="ml-auto">
                    <CommentsButton
                        commentableType="service_case"
                        commentableId={serviceCase.id}
                    />
                </div>
            </div>
        </Box>
    )
}
